/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import searchPlaceHolder from "./placeholder";
import SearchBox from "../../../../shared/components/searchBox";

function HeaderSearchBox() {
  const location = useLocation();
  const searchBoxReference: any = useRef();
  const { payload, setPayload } = useContext(SidebarContext);

  const handleSearch = (value: string) => {
    setPayload((prevData: any) => {
      return {
        ...prevData,
        skip: 0,
        search: value,
      };
    });
  };

  const handleClear = () => {
    if (searchBoxReference?.current) searchBoxReference.current.value = "";
  };

  useEffect(() => {
    handleClear();
  }, [location]);

  const cleanPath = location.pathname.replace(/\/+$/, "");
  const locationArray = cleanPath.split("/").filter(Boolean);
  // const locationArray = location.pathname.split("/");
  let lastUrlItem = locationArray.pop();
  lastUrlItem = lastUrlItem === "id" ? locationArray.pop() : lastUrlItem;

  return (
    searchPlaceHolder?.[`${lastUrlItem}`] && (
      <SearchBox
        placeholder={searchPlaceHolder?.[`${lastUrlItem}`] ?? "Search here"}
        handleSearch={(value: string) => handleSearch(value)}
        value={payload?.search}
        size="medium"
        height="50%"
      />
    )
  );
}

export default HeaderSearchBox;
